module.exports = __webpack_public_path__ + "static/img/qrcode2.80cef8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qrcode2.png
// module id = +rBk
// module chunks = 18